import { render } from "./ModalAddInfoCustomer.vue?vue&type=template&id=4584c165&scoped=true"
import script from "./ModalAddInfoCustomer.vue?vue&type=script&lang=js"
export * from "./ModalAddInfoCustomer.vue?vue&type=script&lang=js"

import "./ModalAddInfoCustomer.vue?vue&type=style&index=0&id=4584c165&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4584c165"]])

export default __exports__